var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',{staticClass:"mt-4 mb-6 pt-1 flicker-card"},[_c('v-row',[_c('v-col',[_c('flicker-percentage-card-info',{attrs:{"test":_vm.test}})],1),_c('v-col',{staticClass:"mr-4"},[_c('flicker-index-card-info',{attrs:{"test":_vm.test}})],1)],1)],1),_c('h4',[_vm._v(_vm._s(_vm.$t("room.illumination.flicker.percentage")))]),_c('niko-slider',{attrs:{"min":-1,"max":100,"suffix":"%","step":"1","value":_vm.measuredFlickerPercentage,"placeholder":"-"},on:{"onChange":function (value) {
        var options = {
          index: _vm.index,
          attribute: 'measured_flicker_percentage',
          newValue: value,
        };
        _vm.changeIlluminationTestAttribute(options);
        _vm.debouncedSetMeasuredFlickerPercentage(value);
      }}}),_c('h4',[_vm._v(_vm._s(_vm.$t("room.illumination.flicker.index")))]),_c('niko-slider',{attrs:{"min":-0.01,"max":1,"step":"0.01","value":_vm.measuredFlickerIndex,"placeholder":"-","textFieldType":"text"},on:{"onChange":function (value) {
        var options = {
          index: _vm.index,
          attribute: 'measured_flicker_index',
          newValue: value,
        };
        _vm.changeIlluminationTestAttribute(options);
        _vm.debouncedSetMeasuredFlickerIndex(value);
      }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }